import { getTabElementPropertiesApi } from '@core/core/api'
import type { AppThunk } from '@core/core/store'

import { tabElementPropertiesSlice } from './tabElementPropertiesSlice'
const { addTabElementProperties } = tabElementPropertiesSlice.actions

export const getTabElementProperties = (): AppThunk => dispatch =>
  getTabElementPropertiesApi().then(res => dispatch(addTabElementProperties(res)))
